var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { EventsService } from "app/lib/EventsService";
import { getAdminMenuTree } from "app/lib/lib";
import { HttpClient } from "@angular/common/http";
import dictionary from "dict/static.json";
import { AuthService } from "../auth.service";
import { NavigationEnd, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
var MenuComponent = /** @class */ (function () {
    function MenuComponent(cdRef, service, eventsService, http, authService, router, titleService) {
        this.cdRef = cdRef;
        this.service = service;
        this.eventsService = eventsService;
        this.http = http;
        this.authService = authService;
        this.router = router;
        this.titleService = titleService;
        this.navbarCollapsed = true;
        this.options = {
            position: ["bottom", "right"],
            timeOut: 3000,
            lastOnBottom: true,
            showProgressBar: false,
        };
        this.nodes = [];
        this.bridgeMap = {};
        this.aclResouceMap = {};
        this.currentMenuItem = '';
        this.cotainerFluidMap = {
            '/accessor': true,
            '/operation_data': true,
            '/perfomance': true,
            '/admin/promopult': true,
            '/billing/zero_day': true,
        };
        var me = this;
        me.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                me.currentMenuItem = event.url.replace(/^\//, '/').split('?')[0];
            }
        });
        // // Если несколько ajax-запросов запущено и они попадали - покажется только одно сообщение об ошибке
        this.eventsService.on('http-error', function (error) {
            me.service.error(error, null, {
                preventDuplicates: true,
            });
            console.error('http-error', error);
        });
        this.eventsService.on('error', function (error) {
            me.service.error(error, null, {
                preventDuplicates: true,
            });
            console.error('error', error);
        });
        this.eventsService.on('info', function (text) {
            me.service.info(text, null, {
                preventDuplicates: true,
            });
        });
    }
    MenuComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Редирект с не ангуляровских фильтров
                if (window.location.href.indexOf('#/') != -1) {
                    window.location.replace(window.location.href.replace('#/', ''));
                }
                this.bridgeMap = dictionary.bridgeMap;
                this.aclResouceMap = dictionary.aclResouceMap;
                this.nodes = getAdminMenuTree();
                return [2 /*return*/];
            });
        });
    };
    MenuComponent.prototype.getContainerClass = function () {
        var routeName = this.router.routerState.snapshot.url.split('?')[0];
        return this.cotainerFluidMap[routeName] ? 'container-fluid' : 'container';
    };
    MenuComponent.prototype.isAllow = function (node) {
        if (this.authService.isProvider && !node.route) {
            return false;
        }
        if (node.route) {
            var resourceName = this.aclResouceMap[node.route];
            return resourceName && this.authService.isAllowResource(resourceName);
        }
        return !!node.url;
    };
    MenuComponent.prototype.isAnyChildrenAllow = function (node) {
        var _this = this;
        if (!this.authService.isProvider && (node.route === 'WL' || node.route === 'uKitAlt')) {
            return true;
        }
        return node.childs.some(function (c) { return _this.isAllow(c); });
    };
    MenuComponent.prototype.onSignOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.signOut().toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.router.navigate(['/sign_in'])];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MenuComponent;
}());
export { MenuComponent };
